// import "core-js";
import Vue from 'vue';
import axios from './router/axios';
import VueAxios from 'vue-axios';
import App from './App';
import ElementUI from 'element-ui';
// import 'amis/sdk/sdk.js';
import 'element-ui/lib/theme-chalk/index.css';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import AvueFormDesign from '@sscfaith/avue-form-design';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import './permission'; // 权限
import './error'; // 日志
import router from './router/router';
import store from './store';
import { loadStyle } from './util/util';
import { isProd, isTest } from './util/runtime';
import * as status from '@/config/env';
import * as urls from '@/config/status';
import {
  iconfontUrl,
  iconfontVersion,
  myIconfont,
  myIconfontUrl,
} from '@/config/env';
import * as filters from './filters'; // 全局filter
import './styles/common.scss';
import basicContainer from './components/basic-container/main';
import * as echarts from 'echarts';
import './util/directive.js';
// vue拓展的全局方法等
import './vue-helper';
import rrWebMonitor from './rrweb';
import { localPlatformKey } from '@/const/common';

// Vue.config.productionTip = false;
/* Vue.config.errorHandler = function (err, vm, info) {
  // 处理错误
  console.error(err, vm, info);
}; */
if (
  window.location.href.indexOf('login') < 0 &&
  sessionStorage.getItem(localPlatformKey) !== 'system'
) {
  sessionStorage.setItem(localPlatformKey, 'dot');
}
window.axios = axios;

Vue.use(VueAxios, axios);
Vue.config.silent = true;
Vue.use(ElementUI, {
  size: 'small',
  menuType: 'text',
});

Vue.use(Avue, {
  size: 'small',
  menuType: 'text',
});

Vue.use(router);

Vue.use(AvueFormDesign);

// 注册全局容器
Vue.component('basicContainer', basicContainer);

Vue.prototype.$echarts = echarts;

// 加载相关url地址
Object.keys(urls).forEach((key) => {
  Vue.prototype[key] = urls[key];
});

//加载状态
Object.keys(status).forEach((key) => {
  Vue.prototype[key] = status[key];
});

//加载过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$stringFormat = function stringFormat(formatted, args) {
  console.log(formatted);
  let newUrl;
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp('\\{' + i + '\\}', 'gi');
    formatted = formatted.replace(regexp, args[i]);
    console.log(formatted);
  }
  return formatted;
};

// 动态加载阿里云字体库
iconfontVersion.forEach((ele) => {
  loadStyle(iconfontUrl.replace('$key', ele));
});
myIconfont.forEach((ele) => {
  loadStyle(myIconfontUrl.replace('$key', ele));
});

Vue.config.productionTip = false;

rrWebMonitor.init(Vue);

Sentry.init({
  Vue,
  dsn: 'https://c57acb18ef72407cb10aa9006c1acbec@sentry.iol8.com/3',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
    }),
    // 开发环境不包裹console，便于明确具体console触发地方
    new Sentry.Integrations.Breadcrumbs({
      console: isProd,
    }),
  ],
  tracesSampleRate: 1.0,
  environment: isProd ? 'prod' : isTest ? 'test' : 'dev',
  logErrors: true,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
